import { LandingHeroProps } from '../../../components';

export const mapDirectusLandingHero = (block): LandingHeroProps => {
  return {};
};
